import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '服务分类', path: '/category' },
  { name: '文章资讯', path: '/articles' },
  { name: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              比基尼护士
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? scrolled
                      ? 'text-primary-500'
                      : 'text-white border-b-2 border-white'
                    : scrolled
                      ? 'text-foreground-600 hover:text-primary-500'
                      : 'text-white/80 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category"
              className={`px-5 py-2 rounded-md text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white border border-white/40 hover:bg-white/30'
              }`}
            >
              立即探索
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-md transition-colors cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-primary-500 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-500 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/category"
              className="mt-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-md text-center cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即探索
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}